import React, { useState } from 'react';
import { useHistory } from 'react-router-dom';
import {
  Button,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TablePagination,
  Paper,
  IconButton,
} from '@material-ui/core';
import { Edit } from '@material-ui/icons';
import { useTranslation } from 'react-i18next';
import PaginationData from 'types/models/PaginationData';
import MPPoint from 'types/models/MPPoint';
import EditMPPointConfigContext from 'contexts/EditMPPointConfigContext';
import { getMPPoints } from 'services/mercadoPagoServices';
export default (): JSX.Element => {
  const history = useHistory();
  const [paginationMPPonints, setPaginationpaginationMPPonints] = useState<PaginationData<MPPoint> | null>(null);
  const { selectedMPPointConfig, setSelectedMPPoint } = React.useContext(EditMPPointConfigContext);
  const { t } = useTranslation();

  React.useEffect(() => {
    loadData();
  }, []);

  const loadData = React.useCallback(async (page?: number) => {
    if (!selectedMPPointConfig) return;
    const paginationData = await getMPPoints(selectedMPPointConfig.id, page);
    if (paginationData) setPaginationpaginationMPPonints(paginationData);
  }, []);

  const renderEditButton = (mercadoPagoPoint: MPPoint): JSX.Element => {
    return (
      <IconButton
        color="inherit"
        onClick={() => {
          setSelectedMPPoint(mercadoPagoPoint);
          history.push('posnets/edit');
        }}
      >
        <Edit />
      </IconButton>
    );
  };

  const renderContent = (paginationData: MPPoint[]): JSX.Element => {
    return (
      <>
        {paginationData.map((mpPoint: MPPoint) => (
          <TableRow key={mpPoint.description}>
            <TableCell component="th" scope="row">
              {mpPoint.description}
            </TableCell>
            <TableCell>{renderEditButton(mpPoint)}</TableCell>
          </TableRow>
        ))}
      </>
    );
  };

  return (
    <div>
      <div className="vertical-bottom-space">
        <Button className="btn-50" variant="contained" color="secondary" onClick={() => history.go(-1)}>
          {t('go-back')}
        </Button>
      </div>
      <TableContainer className="table-container" component={Paper}>
        <Table>
          <TableHead className="table-header">
            <TableRow>
              <TableCell>{t('listMPConfigs-page-description')}</TableCell>
              <TableCell>{t('listMPConfigs-page-edit')}</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {paginationMPPonints?.data && paginationMPPonints?.data.length > 0 ? (
              renderContent(paginationMPPonints.data)
            ) : (
              <TableRow>
                <TableCell component="th" scope="row">
                  {t('listMPConfigs-page-noConfigs')}
                </TableCell>
              </TableRow>
            )}
          </TableBody>
        </Table>
      </TableContainer>
      {paginationMPPonints && (
        <TablePagination
          component="div"
          count={paginationMPPonints.total}
          page={paginationMPPonints.currentPage - 1}
          onPageChange={(_, page: number) => {
            loadData(page + 1);
          }}
          rowsPerPage={paginationMPPonints.perPage}
          rowsPerPageOptions={[]}
          labelDisplayedRows={({ from, to, count }) => {
            return `${from}-${to} ${t('pagination-of')} ${count !== -1 ? count : '0'}`;
          }}
        />
      )}
    </div>
  );
};
